import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 1000,
      staleTime: 0, // Data is always considered stale
      gcTime: 0, // No caching (formerly cacheTime)
      refetchOnMount: true, // Always refetch on mount
      // Disabled: refetching on every tab refocus caused bursts of parallel
      // requests that all hit token expiry at once. Navigating/mounting still
      // refetches (refetchOnMount + staleTime:0), so data stays fresh.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true, // Refetch when reconnecting
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
});